// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__xz66D","page":"Settings_page__gpkOd"};